import { ResumeConversationUseCase } from './ResumeConversationUseCase'
import { conversationRepository } from '../../../data-access/repositories'

export const resumeConversation = new ResumeConversationUseCase({
  conversationRepository,
}).execute
